/**
 * 路由级错误边界（08 基线：任何资源/渲染失败不得出现无法导航的空白页）。
 */
import { useRouteError } from 'react-router';
import { EmptyState } from '@chronospeak/ui';
import { Link } from 'react-router';

export function ErrorBoundaryPage() {
  const error = useRouteError();
  console.error('[web] route error:', error);
  return (
    <main style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}>
      <EmptyState title='页面暂时无法显示' description='内容加载出现了问题，你可以回到小镇首页。'>
        <Link to='/zh-CN'>回到首页</Link>
      </EmptyState>
    </main>
  );
}
